import { Condition } from 'runtime/data/condition';

export class WorkTrayColumn {
    name: string;
    sortName: string;
    valueTypeName: string;
    isVisible: boolean;
    isDescendingSorting: boolean;
    sortSequence: number;
    orderSequence: number;
    displayName: string;
    isSortable: boolean;
    isFilterable: boolean;
    filterConditions: Condition[];
}
